import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { NotificationListApiService } from '../services/notification-list-api.service';
import { NotificationListViewModel, NotificationItem } from '../viewmodels/notification-list-viewmodel';

@Component({
    selector: 'app-notification-list',
    standalone: true,
    imports: [CommonModule, TableModule, ButtonModule, InputTextModule, FormsModule],
    templateUrl: './notification-list.component.html',
    styleUrls: ['./notification-list.component.scss']
})
export class NotificationListComponent implements OnInit {
    viewModel: NotificationListViewModel;

    private notificationListApiService = inject(NotificationListApiService);
    private router = inject(Router);

    constructor() {
        this.viewModel = new NotificationListViewModel(this.notificationListApiService, this.router);
    }

    get filteredNotifications(): NotificationItem[] {
        return this.viewModel.filteredNotifications();
    }

    get searchText(): string {
        return this.viewModel.searchText();
    }

    set searchText(value: string) {
        this.viewModel.searchText.set(value);
    }

    ngOnInit(): void {
        this.viewModel.fetchNotifications();
    }

    applyFilter(): void {
        this.viewModel.applyFilter();
    }

    readMore(notification: NotificationItem): void {
        this.viewModel.readMore(notification);
    }
}
